import { render, staticRenderFns } from "./detailRecord.vue?vue&type=template&id=1cbfa4c3&scoped=true&"
import script from "./detailRecord.vue?vue&type=script&lang=js&"
export * from "./detailRecord.vue?vue&type=script&lang=js&"
import style0 from "./detailRecord.vue?vue&type=style&index=0&id=1cbfa4c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbfa4c3",
  null
  
)

export default component.exports